import { defineMessages } from 'react-intl';

/** Message identities reused across the agents package. */
export const sharedAgentMessages = defineMessages({
  cancel: { defaultMessage: 'Cancel', id: '47FYwba+bI' },
  copied: { defaultMessage: 'Copied', id: 'p556q3uvbn' },
  untitledSession: { defaultMessage: 'Untitled session', id: 'VZOiVMXn0z' },
  couldntResolve: { defaultMessage: "Couldn't resolve", id: 'TajBHFT+ws' },
  none: {
    defaultMessage: 'None',
    id: 'a72Xd2Z21V',
    description: 'Routine overview row value when nothing is set',
  },
});
